import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ServiceUrls } from '../../../util/service-urls';
import { Injectable } from '@angular/core';
import { WsCallback } from '../../../util/ws-callback.interface';
import { WsType } from '../../../util/ws-type';
import { WsResponse } from '../../../util/ws-response.model';

@Injectable()
export class ChangePassword {
    private callback: WsCallback;
    constructor(private http:HttpClient){}

    public setCallback(callBack: WsCallback) {
        this.callback = callBack;
    }

    public changePassword(passwordModel: String) {

        console.log('MODel = ' + passwordModel);

        this.http.post(ServiceUrls.CHANGE_PASSWORD, passwordModel).subscribe(
            data => {
                // this may be incorrect
                //var val = (data as HttpErrorResponse).message;
                var modified = JSON.parse(JSON.stringify(data));
                var res = new WsResponse(
                    modified.status.description,
                    modified.status.code,
                    modified.status.name,
                    modified.payload);
                this.callback.onSuccess(res, WsType.CHANGE_PASSWORD);
            },
            error => {
                if (error.status != '') {
                    var val = (error as HttpErrorResponse).error;
                    var modified = JSON.parse(JSON.stringify(val));
                    var res = new WsResponse(
                        modified.status.description,
                        modified.status.code,
                        modified.status.name,
                        modified.payload);
                    this.callback.onFail(res, WsType.CHANGE_PASSWORD);
                } else {
                    //browser related issues
                    var res = new WsResponse("Unknown error happened");
                    this.callback.onFail(res, WsType.CHANGE_PASSWORD);
                }
            }
        );
    }

}
